import { useMemo } from 'react';

import { useFilterState } from '../../../filters/hooks/useFilters';
import {
  type DateFilter,
  type DateRangeFilter,
  FilterId,
} from '../../../filters/types/filters';

const endOfMonth = (date: Date): number =>
  Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 1) - 1;

const isoDay = (date: Date): string => date.toISOString().slice(0, 10);

const lastDayOfMonth = (date: Date): string =>
  isoDay(new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0)));

export const useSnapshotDateEnd = (): number | null => {
  const { filterState } = useFilterState<DateFilter>(FilterId.SNAPSHOT_DATE);
  const selected = filterState.value;
  return useMemo(() => (selected ? endOfMonth(selected) : null), [selected]);
};

/** The selected Date Range as inclusive ISO days, the lineage data's own format. */
export const useTrendDateRange = (): {
  start: string | null;
  end: string | null;
} => {
  const { filterState } = useFilterState<DateRangeFilter>(FilterId.DATE_RANGE);
  const { min, max } = filterState;
  return useMemo(
    () => ({
      start: min ? isoDay(new Date(min)) : null,
      end: max ? lastDayOfMonth(new Date(max)) : null,
    }),
    [min, max]
  );
};
